import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SkillDocumentResponse, SkillPracticeTaskStatus } from '../../../models/skill-learning.model';
import { TranslationBundle } from '../../../models/translation-bundle.model';
import {
  SKILL_PRACTICE_STATUS_LABELS,
  SKILL_PRACTICE_TASK_STATUS,
} from '../../../options/skill-learning.option';

type SkillDocumentInput = SkillDocumentResponse | null;
type SkillPracticeTaskStatusInput = SkillPracticeTaskStatus | null;

@Component({
  selector: 'app-practice-level',
  templateUrl: './practice-level.component.html',
  styleUrls: ['./practice-level.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PracticeLevelComponent {
  readonly taskStatuses = SKILL_PRACTICE_TASK_STATUS;

  @Input() level: number;
  @Input() description: string = '';
  @Input() descriptionTranslation: TranslationBundle = null;
  @Input() documentFileId: string | null = null;
  @Input() document: SkillDocumentInput = null;
  @Input() taskStatus: SkillPracticeTaskStatusInput = null;
  @Input() assignedCuratorName: string | null = null;
  @Input() assignedCuratorPhone: string | null = null;
  @Input() isDisabled: boolean = false;

  @Output() startClicked = new EventEmitter<void>();

  get isCompleted(): boolean {
    return this.taskStatus === SKILL_PRACTICE_TASK_STATUS.COMPLETED;
  }

  get canStart(): boolean {
    return !this.taskStatus && !this.isDisabled;
  }

  get hasDocument(): boolean {
    return !!this.document || !!this.documentFileId;
  }

  get hasCurator(): boolean {
    return this.canShowCuratorStatus && this.hasCuratorContacts;
  }

  get canShowCuratorStatus(): boolean {
    return this.taskStatus === SKILL_PRACTICE_TASK_STATUS.CREATED
      || this.taskStatus === SKILL_PRACTICE_TASK_STATUS.IN_WORK;
  }

  get hasCuratorContacts(): boolean {
    return !!this.assignedCuratorName || !!this.assignedCuratorPhone;
  }

  get statusLabel(): string {
    if (!this.taskStatus) {
      return '';
    }
    return SKILL_PRACTICE_STATUS_LABELS[this.taskStatus] || '';
  }

  onStartClick(): void {
    if (this.canStart) {
      this.startClicked.emit();
    }
  }

  onDownloadClick(): void {}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/user/practice-level/practice-level.component.ts